<template>
  <div class="double-inspection">
    <div class="inspection-table">
      <el-button size="small" type="primary" @click="handleAdd"
        ><i class="el-icon-plus"></i>{{ $t("add") }}</el-button
      >
      <div class="table_wrap main">
        <el-table width="100%" :data="tableData" border :max-height="computedHeight">
          <el-table-column
            align="center"
            :label="$t('index')"
            type="index"
            width="60"
          ></el-table-column>
          <el-table-column
            :label="$t('jobClassification')"
            show-overflow-tooltip
            prop="typeDesc"
          ></el-table-column>
          <el-table-column align="center" :label="$t('state')" prop="status" width="120">
            <template slot-scope="scope">
              <div>
                {{ scope.row.status === "1" ? $t("on") : $t("off") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('operation')" width="120">
            <template slot-scope="scope">
              <div class="todo_wrap">
                <span @click="handleEdit(scope.row)">{{ $t("edit") }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 设置目标值dialog -->
    <el-dialog
      :title="eTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="50%"
      :before-close="handleDataClose"
    >
      <div class="form_item">
        <el-form ref="dialogForm" :model="dialogData" label-width="160px" :rules="rules">
          <!-- <el-form-item :label="$t('weightDistribution')+':'">
            <el-form-item prop="typeDesc">
              <el-input v-model="dialogData.typeDesc" placeholder="请输入简体中文"></el-input>
            </el-form-item>
            <el-form-item prop="en_TypeDesc">
              <el-input v-model="dialogData.en_TypeDesc" placeholder="請輸入繁體中文描述"></el-input>
            </el-form-item>
            <el-form-item prop="czh_TypeDesc">
              <el-input v-model="dialogData.czh_TypeDesc" placeholder="Please enter English description"></el-input>
            </el-form-item>
          </el-form-item> -->
          <lang-input
            :label="$t('jobClassification') + '：'"
            form-prop="typeDesc"
            :maxlength="100"
            :zhcn.sync="dialogData.simplifyName"
            :zhhk.sync="dialogData.traditionalName"
            :en.sync="dialogData.englishName"
            @update-rules-key="handleSetTypeRules"
          >
          </lang-input>
          <el-form-item :label="$t('state') + ':'" prop="status">
            <template>
              <el-radio v-model="dialogData.status" label="1">{{ $t("on") }}</el-radio>
              <el-radio v-model="dialogData.status" label="0">{{ $t("off") }}</el-radio>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleDataClose">{{ $t("cancel") }}</el-button>
        <el-button type="primary" @click="handleDataDgConfirm">{{
          $t("confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import LangInput from "@/components/LangInput.vue";
import { setLanguage } from "@/utils";

export default {
  data() {
    return {
      eTitle: this.$t("add") + " " + this.$t("weightDistributionConfig"), // 弹框标题
      dialogVisible: false, // 弹框是否展示
      dialogData: {
        typeDesc: "",
        en_TypeDesc: "",
        czh_TypeDesc: "",
        status: "1", // 默认是启用
      }, // 弹框数据
      tableData: [],
      rules: {
        typeDesc: [
          {
            required: true,
            max: 100,
            message: this.$t("weightDistributionCheckTips"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {},
  components: {
    LangInput,
  },
  methods: {
    // 初始化页面列表数据
    initTableData() {
      this.$Service
        .fetch({
          url: "weightDistributeList",
          isUgly: true,
          forceExecute: true,
          methods: "post",
          data: JSON.stringify({}),
        })
        .then((response) => {
          if (response.code == "1") {
            const { data } = response;
            this.tableData = data;
            console.log(this.tableData);
          }
        });
    },
    handleDataClose() {
      this.dialogVisible = false;
      this.$refs.dialogForm.clearValidate();
      this.dialogData.typeDesc = "";
      this.dialogData.status = "1";
    },
    handleSetTypeRules(data) {
      this.$set(this.dialogData, "typeDesc", setLanguage(data));
    },
    handleAdd() {
      this.dialogVisible = true;
      this.dialogData = {
        simplifyName: "",
        traditionalName: "",
        englishName: "",
        status: "1",
      };
    },
    handleDataDgConfirm() {
      // 校验字符长度
      this.$refs.dialogForm.validate((isValid) => {
        if (isValid) {
          // 调一次保存接口
          const requestBody = this.fillLanguage({ ...this.dialogData }, [
            "simplifyName",
            "traditionalName",
            "englishName",
          ]);
          this.$Service
            .fetch({
              url: this.dialogData.id ? "weightDistributeUpdate" : "weightDistributeSave",
              isUgly: true,
              forceExecute: true,
              methods: "post",
              data: JSON.stringify(requestBody),
            })
            .then((response) => {
              if (response.code == "1") {
                const tip = this.$t("success");
                this.$message.success(tip);
                // 调刷新列表
                this.dialogVisible = false;
                this.clearDialogData();
                this.initTableData();
              } else {
                this.$message.error(response.msg);
              }
            });
        }
      });
    },
    //  清空当前弹框的数据
    clearDialogData() {
      (this.eTitle = this.$t("add") + " " + this.$t("weightDistributionConfig")),
        (this.dialogData = {
          typeDesc: "",
          status: "1", // 默认是启用
        });
    },
    handleEdit(row) {
      (this.eTitle = this.$t("edit") + " " + this.$t("weightDistributionConfig")),
        (this.dialogVisible = true);
      console.log(row);
      this.dialogData = { ...row };
    },
  },
  computed: {
    computedHeight() {
      switch (true) {
        case this.isLapTop:
          return "360px";
          break;
        case this.isMediumPc:
          return "600px";
          break;
        default:
          return "680px";
      }
    },
  },
  created() {},
  mounted() {
    this.initTableData();
  },
};
</script>
<style lang="less" scoped>
.double-inspection {
  padding: 15px;
  .inspection-table {
    padding: 12px;
    border-radius: 4px;
    background-color: #fff;
  }
}
.table_wrap {
  margin: 20px 0;
}
.todo_wrap {
  display: flex;
  justify-content: space-around;
  color: #1890ff;
  span {
    cursor: pointer;
  }
}

.form_item {
  display: flex;
  align-items: center;
  & > span {
    display: inline-block;
    width: 150px;
    text-align: right;
  }
}
.form_table {
  padding-left: 80px;
  margin-top: 15px;
}

::v-deep .el-table__cell {
  text-align: center;
}
::v-deep .el-form {
  width: 90%;
  margin: 0 auto;
}
::v-deep .el-form-item__label::before {
  content: "*";
  color: red;
}

::v-deep input[disabled="disabled"] {
  background-color: #fff !important;
}
</style>
